// extracted by mini-css-extract-plugin
export var accordion = "accordion-module--accordion--a54fd";
export var accordionContent = "accordion-module--accordionContent--5928a";
export var arrow = "accordion-module--arrow--23f38";
export var link = "accordion-module--link--073d6";
export var rotated = "accordion-module--rotated--ae5bc";
export var submenuLink = "accordion-module--submenuLink--7283f";
export var submenuTitle = "accordion-module--submenuTitle--efa61";
export var title = "accordion-module--title--28b6f";